import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';
import fonts from '../utils/fonts';

import Antetitulo from './Antetitulo';
import Firma from './Firma';

// const Enfoqueh1 = styled.h1`
//   margin: 0 auto;
//   margin-top: 2rem;
//   margin-bottom: 2.9rem;
//   color: ${colors.black};
//   text-transform: uppercase;
//   font-family: ${fonts.serif}, serif;
//   font-weight: 100;
//   letter-spacing: 0.1rem;
//   @media (max-width: 768px) {
//     font-size: 3.5rem;
//   }
// `;

// const BreakGrande = styled.br`
//   display: none;
//   @media (min-width: 768px) {
//     display: inline;
//   }
// `;

// const Destacado = styled.span`
//   color: ${colors.main};
//   font-family: ${fonts.serif}, serif;
// `;

const Titulo = () => (
  <div>
    {/* <Enfoqueh1>
      Texto profesores <BreakGrande />
      <Destacado>principal </Destacado>
      de Domingo
    </Enfoqueh1> */}
    <Antetitulo contenido="Enfoque de Domingo" />
    <Firma contenido="P. Vera, M. Fossati" fecha="10 de junio, 2018" />
  </div>
);

export default Titulo;



// WEBPACK FOOTER //
// ./src/components/Titulo.js